/**
 * The staff team list, GET /api/internal/teams: every team on the platform
 * with its sidebar config. One query key shared by the Employees page, the
 * impersonation banner, TeamContext (the nav config under impersonation)
 * and the team configuration pages, so one fetch serves all of them and a
 * sidebar save updates every reader at once.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { customFetch } from '@/api/client'
import type { TeamListResponse } from '@/api/generated/model'

export const INTERNAL_TEAMS_QUERY_KEY = ['/api/internal/teams'] as const

export function useInternalTeams(
  options: { enabled?: boolean } = {},
): UseQueryResult<TeamListResponse> {
  return useQuery({
    queryKey: INTERNAL_TEAMS_QUERY_KEY,
    queryFn: () => customFetch<TeamListResponse>('/api/internal/teams'),
    enabled: options.enabled ?? true,
    staleTime: 60_000,
  })
}
